import { tWithKeyAttr as t } from "../i18nHelper";
import { IUserReport } from "../services/types/users.types";

export interface IUserAction {
  text: string;
  value: string;
  path: string;
  disabledForFakeCompanyId?: boolean;
}

/**
make user object to keep lower and upper case fields for different components
 */
export function wrapUserForReport(
  user: any,
  guid: string,
  companyId?: number
): IUserReport {
  return {
    Users: {
      ...user,
      Guid: guid,
      FakeCompanyId: user?.fakeCompanyId ?? null,
      FirstName: user?.firstName ?? "",
      LastName: user?.lastName ?? "",
      Birth: user?.birth,
      Address: user?.address,
      Account: user?.account,
      DateRegister: user?.dateRegister,
      Id: user?.id ?? user?.Id,
      Phone: user?.phone,
      TreatmentGroupId: user?.treatmentGroupId,
      ...(companyId && { CompanyId: companyId }),
    },
    AvailabilityHours: user?.AvailabilityHours ?? null,
    AppointmentsProgramsNum: user?.AppointmentsProgramsNum ?? null,
    AppointmentsProgramStatus: user?.AppointmentsProgramStatus ?? undefined,
    TotalReports: user?.TotalReports ?? 0,
    Recommends: user?.Recommends ?? null,
    RoleName: user?.RoleName ?? null,
  };
}

export function wrapUserWithDualCase(
  user: any,
  guid: string,
  companyId?: number
): any {
  return {
    Users: {
      ...user,
      Guid: guid,
      guid: guid,
      CompanyId: companyId ?? user?.companyId,
      companyId: companyId ?? user?.companyId,
      FakeCompanyId: user?.fakeCompanyId ?? null,
      fakeCompanyId: user?.fakeCompanyId ?? null,
      FirstName: user?.firstName ?? "",
      firstName: user?.firstName ?? "",
      LastName: user?.lastName ?? "",
      lastName: user?.lastName ?? "",
      Birth: user?.birth,
      birth: user?.birth,
      Address: user?.address,
      address: user?.address,
      Account: user?.account,
      account: user?.account,
      DateRegister: user?.dateRegister,
      dateRegister: user?.dateRegister,
      Id: user?.id,
      id: user?.id,
    },
    AvailabilityHours: user?.AvailabilityHours ?? null,
    AppointmentsProgramsNum: user?.AppointmentsProgramsNum ?? null,
    AppointmentsProgramStatus: user?.AppointmentsProgramStatus ?? undefined,
    TotalReports: user?.TotalReports ?? 0,
    Recommends: user?.Recommends ?? null,
    RoleName: user?.RoleName ?? null,
  };
}

export const getUserActionsEditBasic = (): IUserAction[] => [
  { text: "ACTION_REPORT_2", value: "actionsReport", path: "report" },
  { text: "PERSONAL_DETAILS_2", value: "editPersonalData", path: "personal" },
  {
    text: t("QUESTIONNAIRE_REPORTS"),
    value: "questionsReports",
    path: "questions_reports",
  },
];
export const getUserActionsEdit = (): IUserAction[] => [
  ...getUserActionsEditBasic(),
  { text: t("EXERCISES_TITLE"), value: "exercises", path: "exercises" },
  { text: "TREATMENT_PLAN_2", value: "treatmentPlan", path: "treatment_plan" },
  {
    text: "DATA_ANALYSIS",
    value: "dashboardReports",
    path: "therapistDashboard",
    disabledForFakeCompanyId: true,
  },
  {
    text: "CLINICAL_SUMMARY",
    value: "ClinicSummary",
    path: "clinicSummary",
  },
  {
    //להחליף ללאחר שT עובד
    text: "GENERATE_TREATMENT_REPORTS_SUMMARY",
    // text: "הנפק סיכום דוחות טיפול",
    value: "generateTreatmentReportsSummary",
    path: "generate_treatment_reports_summary",
  },
  // {
  //   text: "דו\"ח סיכום פגישות",
  //   value: "meetingsReport",
  //   path: "meetings_report",
  // },

  {
    text: "REPORTS",
    value: "reports",
    path: "reports",
  },
  {
    text: "COMMENTS_TITLE",
    value: "userComments",
    path: "userComments",
  },
  {
    text: "MEETING_RECORDINGS",
    value: "meetingRecordings",
    path: "meetingRecordings",
  },

  // { text: "עדכונים", value: "updates", path: "updates" },
  // { text: "דוח RRM", value: "rrm", path: "rrm" },
  { text: "DOCUMENTS_TITLE", value: "documents", path: "documents" },
  // { text: "מרשמים", value: "prescriptions", path: "prescriptions" },
  // {
  //   text: "דוחות פריוונצ'ר",
  //   value: "prevencherReports",
  //   path: "prevencher_reports",
  // },
  // { text: "דוחות טיפול", value: "treatmentReports", path: "treatment_reports" },
  // { text: "דוחות EMD", value: "emd", path: "emd" },
  // { text: "דוחות GAR", value: "gar", path: "gar" },
];

export const superAdminOptions: IUserAction[] = [
  { text: "ALL_COMPANIES", value: "companies", path: "/companies" },
  { text: "TECH_SUPPORT", value: "support", path: "/supportMessages" },
  { text: "CHAT_WITH_AI", value: "ai", path: "/ai" },
  { text: "TEXT_EDIT", value: "edit", path: "/edit" },
  // { text: "COMPANY_AI_USAGE", value: "companyAiUsage", path: "/company-ai-usage" }, not finished
];
